import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import common_fr from "./traductions/fr/common.json";
import common_de from "./traductions/de/common.json";
import common_en from "./traductions/en/common.json";
import common_es from "./traductions/es/common.json";
import common_it from "./traductions/it/common.json";
import common_nl from "./traductions/nl/common.json";
import common_pt from "./traductions/pt/common.json";

i18n.use(LanguageDetector)
    .init({
        interpolation: {
            escapeValue: false
        },
        lng: 'fr',
        fallbackLng: 'fr',
        resources: {
            fr: {
                common: common_fr
            },
            en: {
                common: common_en
            },
            de: {
                common: common_de
            },
            es: {
                common: common_es
            },
            it: {
                common: common_it
            },
            nl: {
                common: common_nl
            },
            pt: {
                common: common_pt
            },
        },
    });

export default i18n;
